module.exports = __webpack_public_path__ + "img/arrow_right.c7e94502.svg";